<div class="searched-per-column" *ngIf="searched">
    <mat-icon>search</mat-icon>
</div>

<div class="search-per-column">
    <mat-icon [matMenuTriggerFor]="menu" (click)="$event.stopPropagation()"
              *ngIf="column.showSearch !== false">
        arrow_drop_down
    </mat-icon>
    <mat-menu #menu="matMenu" xPosition="before">
        <div fxLayout="row" fxLayoutAlign="center center">
            <div *ngIf="!column.filterValue" fxLayout="row" fxLayoutAlign="center center">
                <input
                    [(ngModel)]="searchByText"
                    pInputText
                    placeholder="Wpisz szukaną frazę"
                    type="text"
                    (click)="$event.stopPropagation()"
                    (keyup.enter)="searchByColumn(column)"
                    class="searchColumnText p-column-filter"
                />
                <mat-icon class="clear-icon"
                          (click)="clearSearchByColumn(column)"
                >
                    clear
                </mat-icon>
                <mat-icon class="search-icon"
                          (click)="searchByColumn(column)"
                >
                    search
                </mat-icon>
            </div>

            <div *ngIf="column.filterValue">
                <ng-container *ngIf="column.filterValue === 'Categories'">
                    <pr-select-tree
                        *ngIf="filteredFilterList.length > 0"
                        #prSelectedTree
                        [data]="filteredFilterList"
                        (selectedCategories)="selectedCategories($event)"
                        [initialSelectedNodeTree]="initialSelectedNodeTree"
                    ></pr-select-tree>
                </ng-container>

                <ng-container *ngIf="column.filterValue !== 'Categories'">
                    <input
                        [(ngModel)]="searchInList"
                        pInputText
                        placeholder="Wpisz szukaną frazę"
                        type="text"
                        (click)="$event.stopPropagation()"
                        class="searchColumnText p-column-filter"
                    />

                    <cdk-virtual-scroll-viewport itemSize="20" class="virtual-list">
                        <div *cdkVirtualFor="let item of filteredFilterList" class="virtual-list-item" fxLayout="column" fxLayoutAlign="center start" (click)="$event.stopPropagation()">
                            <mat-checkbox class="example-margin" [(ngModel)]="filterChecked[item]" (click)="$event.stopPropagation()">
                                {{item}}
                            </mat-checkbox>
                        </div>
                    </cdk-virtual-scroll-viewport>
                </ng-container>

                <div class="buttons" fxLayout="row">
                    <button mat-button fxFlex="auto" (click)="clearSearchInList($event)">
                        <mat-icon class="clear-icon">
                            clear
                        </mat-icon>
                    </button>
                    <button mat-button fxFlex="auto" (click)="searchByColumnList($event)">
                        <mat-icon class="search-icon">
                            search
                        </mat-icon>
                    </button>
                </div>
            </div>
        </div>
    </mat-menu>
</div>
